<template>
    <div class="number-roll" >
      <!-- 显示格式化后的数字 -->
      {{ formattedCurrentValue }} USDT
    </div>
  </template>
  
  <script>
  export default {
    name: 'NumberRoll',
    props: {
      // 最终目标数字（必填，必须为正数）
      target: {
        type: Number,
        required: true,
        validator: (value) => !isNaN(value) && value >= 0
      },
      // 动画时长（毫秒，默认 2 秒）
      duration: {
        type: Number,
        default: 2000,
        validator: (value) => value >= 100
      },
      // 是否显示千位分隔符（默认 true）
      useThousandSeparator: {
        type: Boolean,
        default: true
      },
      // 自定义小数位数，优先级高于自动检测
      decimalPlaces: {
          type: Number,
          default: null,
          validator: (value) => value === null || (Number.isInteger(value) && value >= 0)
      }
    },
    data() {
      return {
        currentValue: 0,
        animationId: null,
        decimalCount: 0 // 记录目标数字的小数位数
      };
    },
    computed: {
      formattedCurrentValue() {
        // 计算要显示的小数位数
        const decimalsToShow = this.decimalPlaces !== null ? this.decimalPlaces : this.decimalCount;
  
        // 1. 四舍五入到指定的小数位数
        const roundedValue = Math.round(this.currentValue * Math.pow(10, decimalsToShow)) / Math.pow(10, decimalsToShow);
  
        // 2. 转换为字符串，并确保小数位数正确（例如，123.4 会变成 "123.40" 如果需要两位小数）
        const valueWithFixedDecimal = roundedValue.toFixed(decimalsToShow);
  
        // 3. 如果不需要千位分隔符，直接返回
        if (!this.useThousandSeparator) return valueWithFixedDecimal;
  
        // 4. 分割整数部分和小数部分
        const [integerPart, fractionalPart] = valueWithFixedDecimal.split('.');
  
        // 5. 对整数部分添加千位分隔符
        const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
        // 6. 合并整数和小数部分
        return fractionalPart ? `${formattedIntegerPart}.${fractionalPart}` : formattedIntegerPart;
      }
    },
    watch: {
      target: {
        handler(newTarget) {
          // 停止之前的动画
          this.stopAnimation();
          // 重置当前值
          this.currentValue = 0;
          // 计算新目标值的小数位数
          this.calculateDecimalCount(newTarget);
          // 启动新动画
          this.startAnimation(newTarget);
        },
        immediate: true
      },
      duration: {
        handler() {
          if (this.target >= 0) {
            this.stopAnimation();
            this.currentValue = 0;
            this.startAnimation(this.target);
          }
        }
      }
    },
    beforeDestroy() {
      this.stopAnimation();
    },
    methods: {
      /**
       * 计算目标数字的小数位数
       * @param {number} num - 目标数字
       */
      calculateDecimalCount(num) {
          if (Number.isInteger(num)) {
              this.decimalCount = 0;
              return;
          }
          const parts = num.toString().split('.');
          this.decimalCount = parts.length > 1 ? parts[1].length : 0;
      },
  
      /**
       * 启动数字滚动动画
       * @param {number} target - 目标数字
       */
      startAnimation(target) {
        let startTime = null;
        const startValue = 0;
  
        const animate = (currentTime) => {
          if (!startTime) startTime = currentTime;
          const progress = Math.min((currentTime - startTime) / this.duration, 1);
          
          // 关键改动：直接计算当前值，不进行取整
          this.currentValue = startValue + (target - startValue) * progress;
          
          if (progress < 1) {
            this.animationId = requestAnimationFrame(animate);
          } else {
              // 动画结束后，确保currentValue精确等于目标值，避免浮点数误差
              this.currentValue = target;
          }
        };
  
        this.animationId = requestAnimationFrame(animate);
      },
  
      /**
       * 停止动画
       */
      stopAnimation() {
        if (this.animationId) {
          cancelAnimationFrame(this.animationId);
          this.animationId = null;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* 组件默认样式（可根据项目需求修改） */
  .number-roll {
    font-size: 2rem;
    font-weight: bold;
    color: #3498db;
    transition: color 0.3s;
  }
  
  /* 可选：添加hover效果 */
  .number-roll:hover {
    color: #2980b9;
  }
  </style>